<template>
  <div ref="wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    minWidth: {
      type: Number,
      default: 200
    }
  },
  data () {
    return {
      elHandler: null,
      elLeft: null,
      isHandlerDragging: false
    }
  },
  mounted () {
    this.initResizable()
  },
  beforeDestroy () {
    // resizable listeners
    this.elHandler.removeEventListener('mousedown', this.onResizeStart)
    this.$refs.wrapper.removeEventListener('mousemove', this.onResizeMove)
    document.removeEventListener('mouseup', this.onResizeEnd)
  },
  methods: {
    initResizable () {
      // https://stackoverflow.com/questions/46931103/making-a-dragbar-to-resize-divs-inside-css-grids/46934825
      this.isHandlerDragging = false

      if (this.$refs.wrapper.childNodes.length !== 2) {
        throw new Error('<pa-resizable> accepts only 2 child elements')
      }

      // resize handler
      const handler = document.createElement('div')
      handler.className = 'pa-resize-handler'

      this.elHandler = this.$refs.wrapper.insertBefore(handler, this.$refs.wrapper.childNodes[1])

      this.elHandler.addEventListener('mousedown', this.onResizeStart)
      this.$refs.wrapper.addEventListener('mousemove', this.onResizeMove)
      document.addEventListener('mouseup', this.onResizeEnd)
    },
    onResizeStart (e) {
      this.elLeft = this.$refs.wrapper.childNodes[0]
      this.isHandlerDragging = true
    },
    onResizeMove (e) {
      // Don't do anything if dragging flag is false
      if (!this.isHandlerDragging) {
        return false
      }

      // Get offset using boundingClient for nested layouts
      const containerOffsetLeft = this.$refs.wrapper.getBoundingClientRect().left

      // Get x-coordinate of pointer relative to container
      const pointerRelativeXpos = e.clientX - containerOffsetLeft

      // Resize box A
      // * 8px is the left/right spacing between .handler and its inner pseudo-element
      // * Set flex-grow to 0 to prevent it from growing
      // * use minWidth due to the strange content of my div
      this.elLeft.style.minWidth = (Math.max(this.minWidth, pointerRelativeXpos - 8)) + 'px'
      this.elLeft.style.flexGrow = 0
    },
    onResizeEnd (e) {
      // Turn off dragging flag when user mouse is up
      this.isHandlerDragging = false
    }
  }
}
</script>

<style lang="scss">
.pa-resize-handler {
  width: 20px;
  padding: 9px 0;
  cursor: ew-resize;
  flex: 0 0 auto !important;

  &::before {
    content: '';
    display: block;
    width: 2px;
    height: 100%;
    background: #d3d3d3;
    margin: 0 auto;
  }

  &:first-child {
    display: none;
  }
}
</style>
